import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll'; // Or your routing Link component

// Removed unused DropdownIcon

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Removed unused isExpertiseDropdownOpen state and toggle function
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Removed setting expertise dropdown state
  };

  // Removed unused toggleExpertiseDropdown function

  const closeDropdown = () => {
    // Removed setting expertise dropdown state
    setIsMobileMenuOpen(false);
  };

  // Removed unused scrollToContact function

  const navItems = [
    { name: 'Home', to: 'hero' },
    { name: 'Services', to: 'services' },
    { name: 'About', to: 'about' },
    { name: 'Contact', to: 'contact' },
  ];

  // Removed unused linkHoverVariant

  const underlineVariant = {
    hidden: { width: 0 },
    visible: { width: "100%", transition: { duration: 0.3 } }
  };

  return (
    <motion.nav 
      className={`fixed w-full z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-white shadow-md' : 'bg-transparent'}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 120, damping: 20 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link 
              to="hero" // Scroll to top or Hero section
              smooth={true}
              duration={500}
              spy={true}
              offset={-80} // Adjust offset based on nav height
              className="text-2xl font-bold tracking-tight cursor-pointer"
            >
              <span className={`${isScrolled || isMobileMenuOpen ? 'text-gray-600' : 'text-gray-400'} hover:text-gray-500 transition-colors`}>Eco</span>
              <span className={`${isScrolled || isMobileMenuOpen ? 'text-sky-600' : 'text-sky-400'} hover:text-sky-500 transition-colors`}>Peak</span>
              <span className={`${isScrolled || isMobileMenuOpen ? 'text-gray-900' : 'text-white'} hover:text-gray-700 transition-colors`}> Force</span>
              <span className={`${isScrolled || isMobileMenuOpen ? 'text-sky-600' : 'text-sky-400'} hover:text-sky-500 transition-colors`}>SAP</span>
            </Link>
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navItems.map((item) => (
                <motion.div 
                  key={item.name} 
                  className="relative group"
                  whileHover="hover" // Group hover state for underline
                >
                  <Link
                    activeClass="text-primary font-semibold"
                    to={item.to}
                    spy={true}
                    smooth={true}
                    offset={-80}
                    duration={500}
                    className={`px-3 py-2 rounded-md text-sm font-medium cursor-pointer ${isScrolled || isMobileMenuOpen ? 'text-gray-700' : 'text-gray-300'} hover:text-primary transition-colors`}
                  >
                    {item.name}
                  </Link>
                  <motion.div 
                    className="absolute bottom-0 left-0 h-0.5 bg-primary"
                    variants={underlineVariant}
                    initial="hidden"
                    // Animate based on parent's hover state
                    // Use group-hover defined on parent motion.div
                    whileHover="visible" 
                  ></motion.div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={toggleMobileMenu}
              type="button"
              className={`inline-flex items-center justify-center p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white ${isScrolled || isMobileMenuOpen ? 'text-gray-700 hover:bg-gray-100' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`}
              aria-controls="mobile-menu"
              aria-expanded={isMobileMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              {isMobileMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" /></svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu, show/hide based on menu state. */}
      <motion.div 
        className={`md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}
        id="mobile-menu"
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: isMobileMenuOpen ? 'auto' : 0, opacity: isMobileMenuOpen ? 1 : 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg">
          {navItems.map((item) => (
            <Link
              key={item.name}
              activeClass="bg-primary text-white" // Mobile active style
              to={item.to}
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              className="text-gray-700 hover:bg-gray-100 hover:text-gray-900 block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
              onClick={closeDropdown} // Close menu on click
            >
              {item.name}
            </Link>
          ))}
        </div>
      </motion.div>
    </motion.nav>
  );
}

export default Navbar; 